// extracted by mini-css-extract-plugin
module.exports = {"container":"cards_container__2nAh3","card":"cards_card__1CqLb","infected":"cards_infected__281pr","recovered":"cards_recovered__26Qnc","deaths":"cards_deaths__lYVzI"};